<template>
  <layout-bigscreen nav_top="0">
    <div
      id="antdVue"
      ref="antdVue"
      :style="themeColorInit(themeColorConfig)"
      class="zoom_bg_color"
      style="width: 100%; height: 100%"
    >
      <div class="antdVue" :style="{ ...calculateStyles }">
        <div
          class="flex flex-direction justify-center benben-flex-layout joefitdaping_491_random_flex_0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100"
        >
          <div
            class="flex flex-wrap align-center justify-center joefitdaping_898_fd0_0 mg-t-0 mg-r-0 mg-b-10 mg-l-0 pd-t-0 pd-r-0 pd-b-20 pd-l-0 w-100 f-c-3 position-relative bg-size-auto"
          >
            <div class="flex flex-wrap align-center joefitdaping_154_fd0_0_c0 position-absolute">
              <!--              <img class='joefitdaping_774_fd0_0_c0_c0' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/03e56738af5b3ecc593d3c6c58203cc6.png" />-->
              <span class="joefitdaping_855_fd0_0_c0_c1 t-20 t-w-4"></span>
              <div class="flex flex-wrap align-center joefitdaping_856_fd0_0_c0_c2 bg-size-auto"></div>
              <span class="joefitdaping_477_fd0_0_c0_c3 t-20 h-10-px t-w-4"></span>
              <span class="joefitdaping_477_fd0_0_c0_c3 t-20 h-10-px t-w-4"></span>
            </div>
            <img
              class="joefitdaping_759_fd0_0_c1"
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/e86a55b2a20775c71c1fb6cc91dd3c1e.png"
            />
            <span class="mg-t-0 mg-r-0 mg-b-10 mg-l-0">{{ 'JoeMe平台数据大屏' }}</span>
            <img
              class="joefitdaping_981_fd0_0_c3"
              src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/d3adc8fbbce7c9aa2bbd0f8ae8ac5a40.png"
            />
            <div class="flex align-center joefitdaping_392_fd0_0_c4 position-absolute">
              <img
                class="joefitdaping_214_fd0_0_c4_c0"
                src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240120/2af63761ef0068fdbbfded13de1d740c.png"
              />

              <benben-real-time
                class="flex align-center justify-center joefitdaping_234_random_fd0_0_c4_c1 t-18 t-w-4"
                format="YYYY-MM-DD HH:mm:ss"
                :has_week="true"
                :refresh_interval="500"
                show_title="true"
                title_position="left"
                title_name="标题"
              >
              </benben-real-time>
            </div>

            <benben-full-screen
              class="flex align-center justify-center joefitdaping_416_random_fd0_0_c5 position-absolute a"
            >
            </benben-full-screen>
          </div>

          <a-row class="benben-grid w-100" :gutter="[8, 8]" type="flex">
            <a-col :xs="24" :md="12" :xl="6" :xxl="6">
              <div class="flex flex-wrap align-center pd-t-0 pd-r-0 pd-b-0 pd-l-10 w-100">
                <div
                  class="flex flex-direction align-start joefitdaping_327_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16"
                >
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '本周用户增长趋势' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                  />
                  <div class="flex flex-wrap align-start w-100 h-100">
                    <benben-line-area-accumul
                      class="w-100 h-100"
                      :field-options="field_options_506087"
                      data_source_type="1"
                      chart_show_type="line-area-accumul"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :linear_gradient_color="[
                        { start: 10, color1: 'rgba(255, 140, 25, .7)', color2: 'rgba(255, 140, 25, 0)' },
                        { start: 50, color1: '#23b7e5', color2: '' },
                      ]"
                      :theme_color="theme_color_4066"
                      :chart-option="chartOptions_random_8473"
                    >
                    </benben-line-area-accumul>
                  </div>
                </div>
                <div
                  class="flex flex-direction align-start joefitdaping_327_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16"
                >
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '用户年龄分布' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                  />
                  <div class="flex flex-wrap align-start w-100 h-100">
                    <benben-pie-ring
                      class="w-100 h-100"
                      :field-options="field_options_369314"
                      data_source_type="1"
                      chart_show_type="pie-ring"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :theme_color="theme_color_2585"
                      :chart-option="chartOptions_random_5378"
                    >
                    </benben-pie-ring>
                  </div>
                </div>
              </div>
            </a-col>

            <a-col :xs="24" :md="12" :xl="12" :xxl="12">
              <div class="flex flex-wrap align-start joefitdaping_625_fd0_1_c1_c0 w-100 bg-size-100 position-relative">
                <div class="flex align-center w-100">
                  <div class="flex align-center joefitdaping_154_fd0_1_c1_c0_c0_c0 w-100 position-absolute">
                    <div class="flex flex-direction flex-wrap align-center pd-t-0 pd-r-40 pd-b-0 pd-l-0 w-100">
                      <benben-light-text
                        class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9 t-w-4"
                        :field-options="field_options_444631"
                        data_source_type="1"
                        chart_show_type="simple-text"
                        :is_abs="false"
                      >
                      </benben-light-text>

                      <span class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5">{{
                        '今日增长用户'
                      }}</span>
                    </div>
                    <div class="flex flex-direction flex-wrap align-center joefitdaping_916_fd0_1_c1_c0_c0_c0_c1 w-100">
                      <benben-light-text
                        class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9"
                        :field-options="field_options_939564"
                        data_source_type="1"
                        chart_show_type="simple-text"
                        :is_abs="false"
                      >
                      </benben-light-text>

                      <span class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5">{{
                        '当前用户总数'
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="flex align-center joefitdaping_897_fd0_1_c1_c0_c1 w-100 position-absolute">
                  <div class="flex flex-direction flex-wrap align-center pd-t-0 pd-r-40 pd-b-0 pd-l-0 w-100">
                    <benben-light-text
                      class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9 t-w-4"
                      :field-options="field_options_227726"
                      data_source_type="1"
                      chart_show_type="simple-text"
                      :is_abs="false"
                    >
                    </benben-light-text>

                    <span class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5">{{ '今日报警数' }}</span>
                  </div>
                  <div class="flex flex-direction flex-wrap align-center joefitdaping_916_fd0_1_c1_c0_c0_c0_c1 w-100">
                    <benben-light-text
                      class="light-text joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 f-c-9"
                      :field-options="field_options_374263"
                      data_source_type="1"
                      chart_show_type="simple-text"
                      :is_abs="false"
                    >
                    </benben-light-text>

                    <span class="joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 f-c-fff t-16 t-w-5">{{ '报警总数' }}</span>
                  </div>
                </div>
              </div>
            </a-col>

            <a-col :xs="24" :md="12" :xl="6" :xxl="6">
              <div class="flex flex-wrap align-center w-100">
                <div
                  class="flex flex-direction align-start joefitdaping_327_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16"
                >
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '本周报警趋势' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                  />
                  <div class="flex flex-wrap align-start w-100 h-100">
                    <benben-line-simple
                      class="w-100 h-100"
                      :field-options="field_options_216304"
                      data_source_type="1"
                      chart_show_type="line-simple"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :theme_color="theme_color_4609"
                      :chart-option="chartOptions_random_2137"
                    >
                    </benben-line-simple>
                  </div>
                </div>
                <!--                <div class="flex flex-direction align-start joefitdaping_327_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16">-->
                <!--                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{('用户性别占比')}}</span>-->
                <!--                  <img class='joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100' src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png" />-->
                <!--                  <div class="flex flex-wrap align-start  w-100 h-100">-->

                <!--                    <benben-pie-base class='joefitdaping_454_random_fd0_1_c2_c0_c1_c2_c0 w-100' :field-options="field_options_470002" data_source_type="1" chart_show_type="pie-base" show_title="false" title_position="left" title_name="标题" :open_drill="false" :chart_drill="{'aid':'','name':'标题','charts_type':'line','chart_show_type':'','modal_type':'1','chart_source_type':1}" :chart-option="chartOptions_random_4976">-->

                <!--                    </benben-pie-base>-->

                <!--                  </div>-->

                <!--                </div>-->
                <div
                  class="flex flex-direction align-start joefitdaping_327_fd0_1_c0_c0_c0 mg-t-0 mg-r-0 mg-b-20 mg-l-0 w-100 bg-size-auto bdr-16"
                >
                  <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '用户性别分布' }}</span>
                  <img
                    class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                    src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/7794c5512c6c405dbe9683fb2c49bb73.png"
                  />
                  <div class="flex flex-wrap align-start w-100 h-100">
                    <benben-pie-ring
                      class="w-100 h-100"
                      :field-options="field_options_470002"
                      data_source_type="1"
                      chart_show_type="pie-ring"
                      show_title="false"
                      title_position="left"
                      title_name="标题"
                      :theme_color="theme_color_2585"
                      :chart-option="chartOptions_random_5378"
                    >
                    </benben-pie-ring>
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>

          <div class="flex flex-wrap align-center pd-0 w-100">
            <div
              class="flex flex-direction align-start joefitdaping_641_fd0_2_c0 mg-t-0 mg-r-10 mg-b-0 mg-l-10 w-100 bg-size-auto"
            >
              <span class="joefitdaping_198_fd0_1_c0_c0_c0_c0 f-c-fff t-20">{{ '报警信息汇总' }}</span>
              <img
                class="joefitdaping_929_fd0_1_c0_c0_c0_c1 w-100"
                src="https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/21da90ca613e8dba247fec9e68435246.png"
              />
              <div class="flex align-start w-100 h-100">
                <big-screen-table
                  class="joefitdaping_937_random_fd0_2_c0_c2_c0 w-100"
                  :field-options="field_options_567167"
                  data_source_type="1"
                  chart_show_type="big_screen_table"
                  show_title="false"
                  title_position="left"
                  title_name="标题"
                  :show_num="10"
                  play_type="one_num"
                  num_width="10"
                  num_shape="circle"
                  num_name="序号"
                  num_top="3"
                  :show_sort="true"
                >
                </big-screen-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout-bigscreen>
</template>
<script>
import { bigScreenMixins, receiveNew } from '@/assets/diypaaspc/diy-generate-big-screen-new.js'
import {
  receive,
  benbenSelectDiy,
  benbenFlexNumberBox,
  scrollList,
  treeSelect,
  simpleSelect,
  multipleSelect,
  cascaderForm,
  checkboxForm,
  switchForm,
  messageReply,
  rangePicker,
  handSignature,
  mixinAddTableItem,
  editorForm,
  qiunDataCharts,
  copyText,
  mixinTableItemChange,
  in_array,
  themeColorInit,
  getUrlKey,
  clearDataPass,
  isEmpty,
  treeEdit,
} from '@/assets/diypaaspc/diy-pass-pc.js'
import { provinceForm } from '@/assets/diypaaspc/province_area.js'
import request from '@/utils/request'
import * as echarts from 'echarts'
import 'echarts-gl'
import 'echarts-liquidfill'
import { mapdata } from '@/assets/diypaaspc/mapdata.js'
import layoutBigscreen from '@/components/layoutBigscreen'
import {
  getUserAddData,
  getHomeData,
  getUserAge,
  getWeekData,
  getUseSexrData,
  getRecordList,
} from '@/api/daping/daping.js'
import { pageHrv } from '@/api/joe/hrv'
export default {
  name: 'joefitdaping',
  components: {
    layoutBigscreen,
  },
  mixins: [bigScreenMixins],
  data() {
    const themeColorConfig = {
      presetApi: {
        getClassifyOne: '',
        getClassifyTow: '',
        getClassifyShop: '',
      },
      themeType: 0,
      themeConfig: [
        {
          colorConfig: [
            '#333333',
            '#666666',
            '#999999',
            '#ffffff',
            '#0052c7',
            '#F02325',
            '#FC9C3A',
            '#4DC777',
            '#F2CC98',
            '#F2CC66',
          ],
          bgColorConfig: [
            '#EBEDF8',
            '#FFFFFF',
            '#0052c7',
            '#FC9C3A',
            '#FC9fff',
            '#E6F333',
            '#E6F1FE',
            'linear-gradient(301deg, #EBBA7B 0%, #F8D9AD 100%)',
            'linear-gradient(180deg, #F5588E 0%, #F0403C 100%)',
            'linear-gradient(179deg, #FFD033 0%, #F4890E 100%)',
          ],
          bdColorConfig: [
            '#EBEDF8',
            '#FFFFFF',
            '#0052c7',
            '#FC9C3A',
            '#333333',
            '#666666',
            '#999999',
            '#dddddd',
            '#1178F0',
            '#F02325',
          ],
        },
      ],
    }
    receive(this)
    receiveNew(this)
    return {
      themeColorConfig,
      mapdata: mapdata,
      field_options_567167: {
        // "columns": [{
        //   "name": "分组织",
        //   "prop": "subsys"
        // }, {
        //   "name": "部门",
        //   "prop": "module"
        // }, {
        //   "name": "业务组",
        //   "prop": "business"
        // }, {
        //   "name": "姓名",
        //   "prop": "name"
        // }, {
        //   "name": "销售额",
        //   "prop": "value",
        //   "accuracy": 1
        // }, {
        //   "name": "地址",
        //   "prop": "url",
        //   "accuracy": 1
        // }],
        // "rows": [{
        //   "subsys": "北京总部",
        //   "module": "市场部",
        //   "business": "第一小分队",
        //   "name": "张三",
        //   "value": 6672389,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "北京总部",
        //   "module": "市场部",
        //   "business": "第一小分队",
        //   "name": "李四",
        //   "value": 7673456.78,
        //   "value_level": "green",
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "北京总部",
        //   "module": "市场二部",
        //   "business": "第二小分队",
        //   "name": "百度",
        //   "__showx_row_level": "red",
        //   "value": "<a href='https://www.baidu.com' target='_blank'>百度链接</a>",
        //   "value_ishtml": true,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售部",
        //   "business": "第三小分队",
        //   "name": "张伟",
        //   "value": 8967569,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售部",
        //   "business": "第三小分队",
        //   "name": "李静",
        //   "value": 5645657,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售部",
        //   "business": "第三小分队",
        //   "name": "完颜付",
        //   "value": 4999889,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售部",
        //   "business": "第三小分队",
        //   "name": "纳兰德",
        //   "value": 8878765,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售二部",
        //   "business": "突击小队",
        //   "name": "迪乌夫",
        //   "value": 7609878,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售二部",
        //   "business": "突击小队",
        //   "name": "南宫强",
        //   "value": 6786546,
        //   "url": "https://www.baidu.com"
        // }, {
        //   "subsys": "上海分部",
        //   "module": "销售二部",
        //   "business": "突击小队",
        //   "name": "萨珊珊",
        //   "value": 3909786,
        //   "url": "https://www.baidu.com"
        // }]
      },
      chartOptions_random_4976: {
        seriesSetting: {
          center: ['50%', '50%'],
          radius: ['0%', '50%'],
          itemStyle: {
            borderColor: '',
            borderWidth: '',
            borderRadius: '',
          },
          startAngle: '',
          type: 'pie',
          label: {
            show: false,
          },
        },
        labelSetting: {
          label: {
            color: '#fff',
            show: true,
            emphasis: {
              show: true,
              textStyle: {
                fontSize: 14,
                color: '#fff',
              },
              rich: {
                a: {
                  fontSize: 14,
                },
              },
            },
          },
          labelLine: {
            show: true,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: true,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        tooltip: {
          show: true,
          autoToolTip: false,
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'inherit',
            fontSize: 14,
          },
        },
      },
      field_options_470002: {
        // "series": [{
        //   "data": [{
        //     "value": 1335,
        //     "name": "苹果"
        //   }, {
        //     "value": 1310,
        //     "name": "三星"
        //   }, {
        //     "value": 1234,
        //     "name": "华为"
        //   }, {
        //     "value": 1350,
        //     "name": "小米"
        //   }, {
        //     "value": 1548,
        //     "name": "oppo"
        //   }]
        // }]
      },
      theme_color_4609: ['#60F262', '#F88000', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      chartOptions_random_2137: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          show: true,
          autoToolTip: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '1%',
          right: '2%',
          bottom: '0%',
          top: '10%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 14,
            fontWeight: 500,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        seriesSetting: {
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              fontSize: 14,
              color: 'inherit',
            },
          },
        },
      },
      field_options_216304: {
        // "xAxis": {
        //   "data": ["周一", "周二", "周三", "周四", "周五", "周六", "周日"]
        // },
        // "series": [{
        //   "smooth": true,
        //   "showSymbol": false,
        //   "name": "心率",
        //   "data": [10, 5, 9, 5, 27, 6, 20],
        //   "type": "line"
        // }, {
        //   "smooth": true,
        //   "showSymbol": false,
        //   "name": "血氧",
        //   "data": [16, 6, 33, 15, 37, 16, 50],
        //   "type": "line"
        // }, {
        //   "smooth": true,
        //   "showSymbol": false,
        //   "name": "体温",
        //   "data": [19, 2, 3, 12, 33, 3, 12],
        //   "type": "line"
        // }]
      },
      field_options_374263: {
        data: 0,
      },
      field_options_227726: {
        data: 0,
      },
      field_options_939564: {
        data: 0,
      },
      field_options_444631: {
        data: 0,
      },
      theme_color_2585: ['#FF5A67', '#11F6F2', '#FF9D00', '#FFC72E', '#00F496', '#00B1FF', '#0F36A2', '#FC658A'],
      chartOptions_random_5378: {
        seriesSetting: {
          center: ['40%', '50%'],
          radius: ['55%', '80%'],
          itemStyle: {
            borderColor: '',
            borderWidth: '',
            borderRadius: '',
          },
          startAngle: '',
          type: 'pie',
          label: {
            color: '#fff',
          },
        },
        labelSetting: {
          label: {
            color: '#fff',
            show: false,
            emphasis: {
              show: false,
              textStyle: {
                fontSize: 14,
                color: '#fff',
              },
              rich: {
                a: {
                  fontSize: 14,
                },
              },
            },
          },
          labelLine: {
            show: true,
          },
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
          },
          show: true,
          orient: 'vertical',
          left: '75%',
          top: 'middle',
        },
        tooltip: {
          show: true,
          autoToolTip: true,
          trigger: 'item',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(255, 0, 0, 0)',
        },
      },
      field_options_369314: {
        // "series": [{
        //   "data": [{
        //     "value": 1335,
        //     "name": "教学质量"
        //   }, {
        //     "value": 1310,
        //     "name": "学生发展"
        //   }, {
        //     "value": 1234,
        //     "name": "校园管理"
        //   }, {
        //     "value": 1350,
        //     "name": "科研创新"
        //   }, {
        //     "value": 1548,
        //     "name": "校园文化"
        //   }]
        // }]
      },
      theme_color_4066: ['#FF8C19', '#F8A200', '#B0D630', '#6EC890', '#2d3c98', '#6AE7E6', '#0F36A2', '#FC658A'],
      chartOptions_random_8473: {
        tooltip: {
          show: true,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
          textStyle: {
            color: 'rgba(255, 255, 255, 1)',
            fontSize: 15,
          },
          autoToolTip: true,
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          borderColor: 'rgba(0, 0, 0, 0)',
        },
        legend: {
          type: 'scroll',
          textStyle: {
            color: '#fff',
          },
          show: false,
          orient: 'horizontal',
          left: 'center',
          top: '',
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '3%',
          top: '10%',
          containLabel: true,
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.1)',
            },
          },
        },
        xAxis: {
          type: 'category',
          axisTick: {
            show: false,
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255, 255, 255, 0.2)',
            },
          },
          axisLabel: {
            show: true,
            color: '#fff',
            fontSize: 12,
            fontWeight: 400,
            rotate: 0,
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#6E7079',
            },
          },
        },
        seriesSetting: {
          areaStyle: {
            show: true,
          },
          markPoint: {
            label: {
              normal: {
                textStyle: {
                  color: '#fff',
                  fontSize: 14,
                  fontWeight: 400,
                },
              },
            },
            itemStyle: [],
            data: [],
            symbol: 'pin',
            symbolSize: 50,
          },
          markLine: {
            data: [],
            lineStyle: {
              type: 'dashed',
            },
            label: {
              color: '#fff',
            },
            symbol: 'none',
          },
          label: {
            normal: {
              show: false,
              position: 'top',
              fontSize: 14,
              color: 'inherit',
            },
          },
        },
      },
      field_options_506087: {
        // "xAxis": {
        //   "data": ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
        // },
        // "series": [{
        //   "name": "",
        //   "data": [320, 342, 159, 376, 320, 342, 159, 376, 320, 342, 159, 376],
        //   "type": "line",
        //   "areaStyle": []
        // }]
      },
      isFullScreen: false,
      big_screen_global_query: {
        screen_global_time_range_type: '5',
        screen_global_time_custom_time: '',
        screen_global_dept: '',
        screen_global_user: '',
        diy_api_time: '',
      },
      saizhuge_api_loaded: false,
      school_info: {},
      weather_info: {},
      weather_data: [
        {
          name: '晴',
          code: '0',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png',
        },
        {
          name: '夜晚晴',
          code: '1',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png',
        },
        {
          name: '晴',
          code: '2',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/37eee88f67459de75005cc6a409e08c9.png',
        },
        {
          name: '夜晚晴',
          code: '3',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/def19f13e5e2779dcaf11446b5ff6c57.png',
        },
        {
          name: '多云',
          code: '4',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/937ea42d4d54677a960419fc926d2308.png',
        },
        {
          name: '晴间多云',
          code: '5',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png',
        },
        {
          name: '晴间多云',
          code: '6',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2be9d1715692cdf209f7f56f85bb5aa7.png',
        },
        {
          name: '大部多云',
          code: '7',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8c1710ce88d626dad374865cc5cc285d.png',
        },
        {
          name: '大部多云',
          code: '8',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/8e47c4a733b6ea39aa94ea362bc942fa.png',
        },
        {
          name: '阴',
          code: '9',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/b8a945d068a4c968e5c05e023a67571f.png',
        },
        {
          name: '阵雨',
          code: '10',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/2987ff71ec8f90fdffa1c0114e13b1f9.png',
        },
        {
          name: '雷阵雨',
          code: '11',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/751a274ee37d368cd45471edc5b35411.png',
        },
        {
          name: '雷阵雨伴有冰雹',
          code: '12',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/2c7657970388a04e29049a23a0046c56.png',
        },
        {
          name: '小雨',
          code: '13',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/6b02916ef905c0f100e3e6d4bf4c4ff0.png',
        },
        {
          name: '中雨',
          code: '14',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/cc26fd0d1cda78eda4b53d85718b8803.png',
        },
        {
          name: '大雨',
          code: '15',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/1598c140199a349d9ec4aed4482f0cf1.png',
        },
        {
          name: '暴雨',
          code: '16',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png',
        },
        {
          name: '大暴雨',
          code: '17',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b460fe42bb0e8dcbc177b5d6ef5b3c30.png',
        },
        {
          name: '特大暴雨',
          code: '18',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/5868a1d8b7bc890f8b7d15df67095c4a.png',
        },
        {
          name: '冻雨',
          code: '19',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/121096065da289cc9ebf23c778c8a4e8.png',
        },
        {
          name: '雨夹雪',
          code: '20',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d9c47f9707616842680ba38e1c8e4d43.png',
        },
        {
          name: '阵雪',
          code: '21',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/af6e554f62f546c76b3b495df7f36eb2.png',
        },
        {
          name: '小雪',
          code: '22',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/71744d3bd3230b10f5d09666a76657ea.png',
        },
        {
          name: '中雪',
          code: '23',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a29d1ac31de2a2cdaecfb4c579cdf928.png',
        },
        {
          name: '大雪',
          code: '24',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/62145c7aea6a3e65c5f1dc8d84f5c92d.png',
        },
        {
          name: '暴雪',
          code: '25',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/50946c87ed7c0e4c471d7cb0310115c3.png',
        },
        {
          name: '浮尘',
          code: '26',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/46258a78adc3acf03d0186836e89b798.png',
        },
        {
          name: '扬沙',
          code: '27',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/a2440c63509d48eb1fa45804c6476f7d.png',
        },
        {
          name: '沙尘暴',
          code: '28',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/9a80471d8001ea814aa4206d3feda602.png',
        },
        {
          name: '强沙尘暴',
          code: '29',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/da4066fc0584850d72ec402894765b2d.png',
        },
        {
          name: '雾',
          code: '30',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240130/4cf7128b075acfd65af6ea175f7240ce.png',
        },
        {
          name: '霾',
          code: '31',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/c6325f4ef718e9aef9dbff86e2d28817.png',
        },
        {
          name: '风',
          code: '32',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/dccb4227577c4f0e51c6b9b16fa75af1.png',
        },
        {
          name: '大风',
          code: '33',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/b1d9445881a4a9d0b1471f831d3800c8.png',
        },
        {
          name: '飓风',
          code: '34',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d58120ad96b2b4df9f4ffb35dc07c3c7.png',
        },
        {
          name: '热带风暴',
          code: '35',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/3ca919f2ae75739b3196460dfffdd405.png',
        },
        {
          name: '龙卷风',
          code: '36',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png',
        },
        {
          name: '冷',
          code: '37',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/785316e069cc774d7a540625f82b7973.png',
        },
        {
          name: '热',
          code: '38',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/d33c81b9f8772998d9bba7d3ea52acb0.png',
        },
        {
          name: '未知',
          code: '99',
          img_url:
            'https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240201/db353a99b557f85968a262210c69f0d7.png',
        },
      ],
      viewSource: 'PC',
      big_screen_global_config: {
        is_screen_global_time: false,
        is_screen_global_dept: false,
        is_screen_global_user: false,
      },
      designWidth: 1920,
      designHeight: 1080,
      calculateStyles: {},
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      timerW: false,
      timerH: false,
      page_scale: 1,
    }
  },
  filters: {},
  created() {
    if (getUrlKey('viewSource')) {
      this.viewSource = getUrlKey('viewSource')
    }
    this.get_diy_api_page()
    this.getUserAddData()
    this.getHomeData()
    this.getUserAge()
    this.getWeekData()
    this.getUseSexrData()
    this.getRecordList()
  },
  mounted() {
    let that = this
    window.onresize = () => {
      that.screenWidth = that.$refs.antdVue.offsetWidth
      that.screenHeight = that.$refs.antdVue.offsetHeight
      that.handleResize()
    }
    this.$nextTick(() => {
      that.handleResize()
    })
  },
  computed: {},
  watch: {
    screenWidth(val) {
      if (!this.timerW) {
        let that = this
        // that.screenWidth = val;
        this.timerW = true
        that.handleResize()
        setTimeout(function () {
          that.timerW = false
        }, 400)
      }
    },
    screenHeight(val) {
      if (!this.timerH) {
        let that = this
        // that.screenHeight = val;
        this.timerH = true
        that.handleResize()
        setTimeout(function () {
          that.timerH = false
        }, 400)
      }
    },
  },

  methods: {
    getRecordList() {
      getRecordList().then((response) => {
        this.field_options_567167 = {
          columns: [
            {
              name: '用户昵称',
              prop: 'nickname',
            },
            {
              name: '异常类型',
              prop: 'dataType',
            },
            {
              name: '异常值',
              prop: 'abnormalData',
            },
            {
              name: '标准值',
              prop: 'standardData',
            },
            {
              name: '异常时间',
              prop: 'createTime',
              accuracy: 1,
            },
          ],
          rows: response.data,
        }
      })
    },

    getUseSexrData() {
      getUseSexrData().then((response) => {
        this.field_options_470002 = {
          series: [
            {
              data: response.data,
            },
          ],
        }
      })
    },

    getWeekData() {
      getWeekData().then((response) => {
        this.field_options_216304 = {
          xAxis: {
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          },
          series: response.data,
        }
      })
    },

    getUserAge() {
      getUserAge().then((response) => {
        this.field_options_369314 = {
          series: [
            {
              data: response.data,
            },
          ],
        }
      })
    },

    getHomeData() {
      getHomeData().then((response) => {
        this.field_options_444631 = { data: response.data.today }
        this.field_options_939564 = { data: response.data.total }
        this.field_options_227726 = { data: response.data.todayMess }
        this.field_options_374263 = { data: response.data.totalMess }
      })
    },

    getUserAddData() {
      getUserAddData().then((response) => {
        this.field_options_506087 = {
          xAxis: {
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          },
          series: [
            {
              name: '',
              data: response.data,
              type: 'line',
              areaStyle: [],
            },
          ],
        }
      })
    },

    copyText,
    mixinTableItemChange,
    in_array,
    themeColorInit,
    isEmpty,
    //统一获取自定义接口
    get_diy_api_page() {},
    handleResize() {
      let that = this
      this.$nextTick(() => {
        that.screenWidth = that.$refs.antdVue.offsetWidth
        that.screenHeight = that.$refs.antdVue.offsetHeight
        let screenWidth = that.screenWidth
        let screenHeight = that.screenHeight
        let scale = Math.min(screenWidth / this.designWidth, screenHeight / this.designHeight)
        let horizontalOffset = (screenWidth - this.designWidth * scale) / 2
        that.calculateStyles = {
          transformOrigin: 'top left',
          transform: `translateX(${horizontalOffset}px)  scale(${scale}) `,
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
@import 'https://zhongtai.zhongbenruanjian.com/static/diypaaspc/css/diy-pass-pc.css';
@import '../assets/diypaaspc/diy-pass-big-screen.css';
@import '../assets/diypaaspc/library-ant-design-vue.css';

.antdVue {
  position: relative;
  width: 100%;
  width: 1920px;
  height: 1080px;
  overflow-y: hidden;
  background: transparent;
  background-size: 100% 100% !important;
}

.zoom_bg_color {
  background: rgba(2, 8, 15, 0);
}

#antdVue .joefitdaping_491_random_flex_0 {
  background-position: 0px 10px;
}

#antdVue .joefitdaping_937_random_fd0_2_c0_c2_c0 {
  height: 150%;
}

#antdVue .joefitdaping_641_fd0_2_c0 {
  background: rgba(38, 95, 255, 0.1);
  height: 300px;
  padding: 16px;
  border-radius: 16px;
}

#antdVue .joefitdaping_454_random_fd0_1_c2_c0_c1_c2_c0 {
  height: 210px;
}

#antdVue .joefitdaping_897_fd0_1_c1_c0_c1 {
  left: 0px;
  bottom: 92px;
}

#antdVue .joefitdaping_916_fd0_1_c1_c0_c0_c0_c1 {
  padding: 0px 0px 0px 55px;
}

#antdVue .joefitdaping_567_fd0_1_c1_c0_c0_c0_c0_c1 {
  font-family: PingFang SC, PingFang SC;
}

#antdVue .joefitdaping_435_random_fd0_1_c1_c0_c0_c0_c0_c0 {
  font-size: 42px;
  font-family: PangMenZhengDaoBiaoTiTiMianFeiBan-2;
}

#antdVue .joefitdaping_154_fd0_1_c1_c0_c0_c0 {
  top: 100px;
  left: 0px;
}

#antdVue .joefitdaping_625_fd0_1_c1_c0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/cfb7f7a0d0e6c70741804b5b1b3df482.png)
    no-repeat;
  height: 593px;
}

#antdVue .joefitdaping_929_fd0_1_c0_c0_c0_c1 {
  height: 4px;
  border-radius: 0px 0px 0px 0px;
  margin: 16px 0px 16px 0px;
  min-height: 4px;
}

#antdVue .joefitdaping_198_fd0_1_c0_c0_c0_c0 {
  font-weight: 800;
  font-family: Source Han Sans SC, Source Han Sans SC;
}

#antdVue .joefitdaping_327_fd0_1_c0_c0_c0 {
  background: rgba(38, 95, 255, 0.1);
  height: 288px;
  padding: 016px;
}

#antdVue .joefitdaping_416_random_fd0_0_c5 {
  width: 70px;
  height: 70px;
  --full-screen-color: rgba(255, 255, 255, 1);
  --full-screen-width: 35px;
  --full-screen-height: 35px;
  top: 28px;
  right: 100px;
  z-index: 99;
}

#antdVue .joefitdaping_234_random_fd0_0_c4_c1 {
  color: rgba(255, 255, 255, 1);
}

#antdVue .joefitdaping_214_fd0_0_c4_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 8px 0px 0px;
}

#antdVue .joefitdaping_392_fd0_0_c4 {
  width: 300px;
  top: 38px;
  right: 180px;
  height: 50px;
}

#antdVue .joefitdaping_981_fd0_0_c3 {
  width: 48px;
  height: 48px;
  border-radius: 0px 0px 0px 0px;
  margin: 0px 0px 0px 8px;
}

#antdVue .joefitdaping_759_fd0_0_c1 {
  width: 48px;
  height: 48px;
  margin: 0px 8px 0px 0px;
}

#antdVue .joefitdaping_477_fd0_0_c0_c3 {
  margin: 0px 0px 0px 8px;
  line-height: 10px;
}

#antdVue .joefitdaping_856_fd0_0_c0_c2 {
  background: linear-gradient(180deg, rgba(216, 226, 255, 0) 0%, #e3eaff 49%, rgba(216, 226, 255, 0) 100%);
  width: 2px;
  height: 16px;
  margin: 0px 0px 0px 8px;
}

#antdVue .joefitdaping_855_fd0_0_c0_c1 {
  margin: 0px 0px 0px 8px;
}

#antdVue .joefitdaping_774_fd0_0_c0_c0 {
  width: 32px;
  height: 32px;
  border-radius: 0px 0px 0px 0px;
}

#antdVue .joefitdaping_154_fd0_0_c0 {
  top: 38px;
  left: 82px;
  height: 50px;
}

#antdVue .joefitdaping_898_fd0_0 {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240124/95867b2fe8e71f9cd1cf14259ed09824.png)
    no-repeat;
  font-size: 48px;
  height: 135px;
  font-weight: 800;
}

.zoom_bg_color {
  background: url(https://zhongben-crm.oss-cn-zhangjiakou.aliyuncs.com/uploads/images/20240329/ebd7c249e0835c522a97191e0c730bec.png)
    center / 100% 100% no-repeat !important;
  overflow: hidden;
}
</style>